export function isVI (state){
    return state.subscriber.identification === '800198348'
}



// WEBPACK FOOTER //
// ./src/modules/login/getters.js